import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Image as ImageIcon, Loader2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { categoriesAPI } from '../services/api';

// Button + progress for the AI illustrations of sub-categories without image (level 3 by default). `categoryId` restricts the scope.
const SubcategoryImagesAI = ({ categoryId = null, scope = 'level3', onDone, testId = 'subimages-ai' }) => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const wasRunning = useRef(false);
  const load = useCallback(() => categoriesAPI.subImagesStatus(categoryId).then((s) => {
    setSt(s);
    if (wasRunning.current && !s.job.running) { wasRunning.current = false; onDone?.(s.job); toast.success(`Images IA : ${s.job.done} générée(s)${s.job.failed ? ` · ${s.job.failed} échec(s)` : ''}`); }
    if (s.job.running) wasRunning.current = true;
  }).catch(() => {}), [categoryId, onDone]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!st?.job?.running) return undefined;
    const id = setInterval(load, 4000);
    return () => clearInterval(id);
  }, [st?.job?.running, load]);

  if (!st) return null;
  const missing = scope === 'all' ? st.missing_all : st.missing_level3;
  const running = st.job.running;
  const start = async () => {
    const label = scope === 'all' ? 'sous-catégorie(s) sans image' : 'sous-sous-catégorie(s) sans image';
    if (!window.confirm(`Générer par IA une illustration pour ${Math.min(missing, st.max_per_job)} ${label}${categoryId ? ' de cette catégorie' : ''} ? Photo studio de la pièce sur fond blanc, visible dans les puces, le menu et les pages. Tâche de fond (≈ 20 s par image), alerte admin à la fin.`)) return;
    setBusy(true);
    try {
      const r = await categoriesAPI.generateSubImages({ category_id: categoryId, scope });
      if (r.started) { wasRunning.current = true; toast.success(`Génération lancée (${r.count} image(s))`); load(); } else toast.info(r.message || 'Une génération est déjà en cours');
    } catch (e) { toast.error(e.response?.data?.detail || 'Lancement impossible'); } finally { setBusy(false); }
  };
  return (
    <span className="inline-flex items-center gap-2" data-testid={testId}>
      <Button type="button" onClick={start} disabled={busy || running || missing === 0} variant="outline" className="border-pink-400 text-pink-700 hover:bg-pink-50" data-testid={`${testId}-button`} title="Génère par IA une photo produit pour chaque sous-(sous-)catégorie encore sans visuel">
        {running ? <Loader2 size={16} className="mr-1 animate-spin" /> : <ImageIcon size={16} className="mr-1" />}
        {running ? `Images IA… ${st.job.done + st.job.failed}/${st.job.total}` : `${scope === 'all' ? 'Images manquantes (IA)' : 'Images niveau 3 (IA)'} (${missing})`}
      </Button>
      {running && st.job.current && <span className="text-[11px] text-gray-500 inline-flex items-center gap-1" data-testid={`${testId}-current`}><Sparkles size={11} className="text-pink-500" /> {st.job.current}</span>}
    </span>
  );
};

export default SubcategoryImagesAI;
